import type { AudioConsentMetadata } from '@/types'

export const RECORDING_CONSENT_NOTICE =
  'Please ensure that all participants have been informed that this call will be recorded and that their consent has been obtained in accordance with your organisation’s policies and applicable legal requirements.'

export const RECORDING_CONSENT_ACKNOWLEDGEMENT =
  'By selecting confirm, you acknowledge that you have obtained the necessary consent prior to recording. For self-reported voice notes, please click Confirm for consent, as it is not required.'

export function createConsentMetadata(consentConfirmed: boolean): AudioConsentMetadata {
  return {
    participants: [],
    recordingWithoutParticipants: true,
    consentDescription: `${RECORDING_CONSENT_NOTICE}\n\n${RECORDING_CONSENT_ACKNOWLEDGEMENT}`,
    consentConfirmed,
  }
}
